import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/service-break-locations'

export const ServiceBreakLocationsBaseRoutes = {
  route: baseRoute,
  List: {
    route: '',
  },
  DetailView: {
    route: '/:serviceBreakLocationId',
  },
}

export const ServiceBreakLocationsAreaRoutes = transformRoutes(
  ServiceBreakLocationsBaseRoutes,
)
